import { type ReactNode } from 'react'
import { useMideyeAuth } from '@mideye/auth-react'
import type { UserInfo } from '../types/api'
import { AuthContext } from './auth-context'

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useMideyeAuth<UserInfo>()

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}